import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import InputSwitch, { SwitchSize } from '../Switch/Switch';

interface Props {
  onChange: (value: boolean) => void;
  checked?: boolean;
  unknownSwitchLabel?: string;
}

const SwitchCompaniesUnknowns: React.FC<Props> = ({
  onChange,
  checked = true,
  unknownSwitchLabel,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box mb={4}>
      <Grid container direction="row">
        <Grid item className={classes.gridText}>
          <Typography className={classes.typography}>
            {unknownSwitchLabel
              ? t(unknownSwitchLabel)
              : t('companies:filterInputs.includeCompaniesIfUnknown')}
          </Typography>
        </Grid>
        <Grid item>
          <InputSwitch fieldName="" checked={checked} onChange={onChange} size={SwitchSize.small} />
        </Grid>
      </Grid>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  gridText: {
    width: 'calc(100% - 48px)',
    display: 'flex',
    alignItems: 'center',
  },
  typography: {
    fontSize: theme.typography.fontSize - 2,
  },
}));

export default SwitchCompaniesUnknowns;
